export default "__VITE_ASSET__Ch6DM14E__"